import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Button } from "@progress/kendo-react-buttons";
import { BatchService } from "../services/BatchServices";
import { useNavigate } from 'react-router-dom';

export interface BatchProps {
  Id: number;
  Title: string;
  Total: number;
  Subtitle: string;
  Date: string;
  ShowButtonRelease: boolean;
  ShowButtonResume: boolean;
  ShowButtonStart: boolean;
  SourceTypeId: string;
  onReleaseBatch: (batchId: number) => void;
  ChannelDescription: string;
}

const Batch: React.FC<BatchProps> = ({
  Title,
  Total,
  Subtitle,
  Date,
  ShowButtonRelease,
  ShowButtonResume,
  ShowButtonStart,
  Id,
  SourceTypeId,
  onReleaseBatch,
  ChannelDescription,
}) => {
  
  const navigate = useNavigate();
  const batchService = new BatchService();
  const { t } = useTranslation();

   const handleStart = () => {
    batchService.StartBatch(Id, Number(SourceTypeId)).then((result) => {
        navigate("/dashboard/labeling", { state: { from: { operation: "work", batchId: result, sourceTypeId: SourceTypeId } } });
    });
  }

  const handleResumeBatch = () => {   
        navigate("/dashboard/labeling", { state: { from: { operation: "resume", batchId: Id, sourceType: SourceTypeId } } });   
  }

  const handleReleaseBatch = () => {
    batchService.ReleaseBatch(Id).then((result) => {
        onReleaseBatch(Id);
    });
  }

  return (
    <div className="batch">
      <div>
        <h5>{Title}</h5>
        <p className="batch-subtitle">
          {Subtitle}
        </p>
      </div>
      <div>
        <p className="batch-data">{`${ChannelDescription} ${moment(Date).format("YYYY-MM-DD")}`}</p>
        <p>
          {ShowButtonResume && (
            <span className="batch-button">
              <Button themeColor="primary" onClick={() => handleResumeBatch()} >             
                {t("general.resumeLabeling")}
              </Button>
            </span>
          )}
          {ShowButtonRelease && (
            <span className="batch-button">
              <Button themeColor="primary" onClick={() => handleReleaseBatch()} >      
                {t("general.releaseBatch")}
              </Button>
            </span>
          )}
          {ShowButtonStart && (
            <span className="batch-button">
              <Button themeColor="primary" onClick={() => handleStart()} >
                {t("general.startLabeling")}
              </Button>            
            </span>
          )}
        </p>
      </div>

    </div>
  );
};

export default Batch;